import store from "@/store/index";
import { Role } from "@/router/role";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/default"),
  },
  {
    path: "/dashboard/accountant",
    name: "DashboardAccountant",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/dashboards/accountant"),
  },
  {
    path: "/dashboard/accountant/detail-po",
    name: "DashboardAccountantDetailPO",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/dashboards/accountant-detail-po"),
  },
  {
    path: "/dashboard/stocker",
    name: "DashboardStocker",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/dashboards/stocker"),
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/account/profile"),
  },
  {
    path: "/add-session",
    name: "AddSession",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/account/add-session"),
  },
  {
    path: "/get-started",
    name: "Get Started",
    meta: {
      authRequired: true,
      authorize: [Role.OWNER],
    },
    component: () => import("./views/get-started/index"),
  },
  {
    path: "/orders",
    name: "Order",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/order/index"),
  },
  {
    path: "/follow-order",
    name: "Follow Order",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/order/follow-order.vue"),
  },
  {
    path: "/request-orders",
    name: "RequestOrder",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/order/request"),
  },
  {
    path: "/sell",
    name: "Sell",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/order/sell"),
  },
  {
    path: "/sell-salesman-delivery",
    name: "SellSalesmanDelivery",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/order/sell-salesman-delivery"),
  },
  {
    path: "/return-promotion/donation",
    name: "ReturnPromotionDonation",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/return-promotion-salesman/donation"),
  },
  {
    path: "/purchase",
    name: "Purchase",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/order/purchase"),
  },
  {
    path: "/order/create",
    name: "Order Create",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES],
    },
    component: () => import("./views/order/create"),
  },
  {
    path: "/direct-sell",
    name: "OrderDirectSell",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/order/direct-sell"),
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetail",
    meta: {
      authRequired: true,
      authorize: [
        Role.TELESALES,
        Role.WAREHOUSE_KEEPER,
        Role.DEBT_ACCOUNTANT,
        Role.BRAND_MANAGER,
      ],
    },
    component: () => import("./views/order/detail"),
  },
  {
    path: "/order/wait",
    name: "Order Wait",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES],
    },
    component: () => import("./views/order/wait-confirm"),
  },
  {
    path: "/order/complete",
    name: "Order Complete",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES],
    },
    component: () => import("./views/order/complete"),
  },
  {
    path: "/order/salesman-delivery",
    name: "OrderSalesmanDelivery",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/order/salesman-delivery"),
  },
  {
    path: "/change-shipper",
    name: "ChangeShipper",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/change-shipper/index"),
  },
  {
    path: "/customers",
    name: "Customers",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES, Role.BRAND_MANAGER, Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/customer/list"),
  },
  {
    path: "/customer/group",
    name: "CustomerGroup",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES, Role.BRAND_MANAGER, Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/customer/group"),
  },
  {
    path: "/customer/detail/:id",
    name: "CustomerDetail",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES, Role.BRAND_MANAGER, Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/customer/detail"),
  },
  {
    path: "/unit",
    name: "Unit",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/unit/list"),
  },
  {
    path: "/unit/convert",
    name: "UnitConvert",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/unit/convert"),
  },
  {
    path: "/inventory/export",
    name: "InventoryExport",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/export"),
  },
  {
    path: "/inventory/export/create",
    name: "InventoryExportCreate",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/export-create"),
  },
  {
    path: "/inventory/export/detail/:id",
    name: "InventoryExportDetail",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/export-detail"),
  },
  {
    path: "/inventory/export/return/:id",
    name: "InventoryExportReturn",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/export-return"),
  },
  {
    path: "/inventory/import",
    name: "InventoryImport",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/import"),
  },
  {
    path: "/inventory/import/create",
    name: "InventoryImportCreate",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/import-create"),
  },
  {
    path: "/inventory/import/detail/:id",
    name: "InventoryImportDetail",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER, Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/inventory/import-detail"),
  },
  {
    path: "/inventory/import/return/:id",
    name: "InventoryImportReturn",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/import-return"),
  },
  {
    path: "/inventory/check",
    name: "InventoryCheck",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/check"),
  },
  {
    path: "/inventory/check/create",
    name: "InventoryCheckCreate",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/check-create"),
  },
  {
    path: "/inventory/check/detail/:id",
    name: "InventoryCheckDetail",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/check-detail"),
  },
  {
    path: "/report/inventory",
    name: "ReportInventory",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/report/inventory"),
  },
  {
    path: "/report/inventory-summary",
    name: "ReportInventorySummary",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER, Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/inventory-summary"),
  },
  {
    path: "/report/inventory-detail/:sku",
    name: "ReportInventoryDetail",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER, Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/inventory-detail"),
  },
  {
    path: "/report/collect-pay",
    name: "ReportCollectPay",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/collect-pay"),
  },
  {
    path: "/report/collect-pay/detail",
    name: "ReportCollectPayDetail",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/collect-pay-detail"),
  },
  {
    path: "/report/export-for-salesman",
    name: "ReportExportForSalesman",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/report/export-for-salesman"),
  },
  {
    path: "/report/item-not-quantity",
    name: "ReportItemNotQuantity",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/report/item-not-quantity"),
  },
  {
    path: "/report/debt-customer",
    name: "ReportDebtCustomer",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/debt-customer-overview"),
  },
  {
    path: "/report/debt-salesman",
    name: "ReportDebtSalesman",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/debt-salesman-overview"),
  },
  {
    path: "/report/item-donation",
    name: "ReportItemDonation",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/item-donation"),
  },
  {
    path: "/report/revenue",
    name: "ReportRevenue",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/revenue"),
  },
  {
    path: "/report/revenue-by-brand",
    name: "ReportRevenueByBrand",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/revenue-by-brand"),
  },
  {
    path: "/report/revenue-by-item",
    name: "ReportRevenueByItem",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/revenue-by-item"),
  },
  {
    path: "/report/shipper",
    name: "ReportShipper",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/report/shipper"),
  },
  {
    path: "/report/shipper-debt",
    name: "ReportShipper",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/shipper-debt"),
  },
  {
    path: "/report/return-item",
    name: "ReportReturnItem",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT, Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/report/return-overview"),
  },
  {
    path: "/report/import-item-trademark",
    name: "ReportImportItemTrademark",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT, Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/report/import-item-trademark"),
  },
  {
    path: "/report/check-otp",
    name: "CheckOtp",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/check-otp"),
  },
  {
    path: "/report/cost-price",
    name: "CostPriceReport",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/report/cost-price.vue"),
  },
  {
    path: "/settings/inventory",
    name: "Inventory",
    meta: {
      authRequired: true,
      authorize: [Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/inventory/list"),
  },
  {
    path: "/settings/distributor",
    name: "Distributor",
    meta: {
      authRequired: true,
      authorize: [Role.ADMIN],
    },
    component: () => import("./views/settings/distributor"),
  },
  {
    path: "/settings/rule",
    name: "Rule",
    meta: {
      authRequired: true,
      authorize: [Role.OWNER],
    },
    component: () => import("./views/settings/index"),
  },
  {
    path: "/agency",
    name: "Agency",
    meta: {
      authRequired: true,
      authorize: [Role.ADMIN],
    },
    component: () => import("./views/agency/list"),
  },
  {
    path: "/warehouse",
    name: "Warehouse",
    meta: {
      authRequired: true,
      authorize: [Role.ADMIN],
    },
    component: () => import("./views/warehouse/list"),
  },
  {
    path: "/brand",
    name: "Brand",
    meta: {
      authRequired: true,
      authorize: [Role.ADMIN],
    },
    component: () => import("./views/brand/list"),
  },
  {
    path: "/region",
    name: "Region",
    meta: {
      authRequired: true,
      authorize: [Role.ADMIN],
    },
    component: () => import("./views/region/list"),
  },
  {
    path: "/item",
    name: "Item",
    meta: {
      authRequired: true,
      authorize: [Role.BRAND_MANAGER],
    },
    component: () => import("./views/item/list"),
  },
  {
    path: "/item-accountant",
    name: "ItemAccountant",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/item-accountant/list"),
  },
  {
    path: "/item/group",
    name: "ItemGroup",
    meta: {
      authRequired: true,
      authorize: [Role.ADMIN],
    },
    component: () => import("./views/item/group"),
  },
  {
    path: "/item/price",
    name: "ItemPrice",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/item/price"),
  },
  {
    path: "/item/threshold",
    name: "ItemThreshold",
    meta: {
      authRequired: true,
      authorize: [Role.BRAND_MANAGER],
    },
    component: () => import("./views/item/threshold"),
  },
  {
    path: "/quotation",
    name: "Quotation",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/quotation/list"),
  },
  {
    path: "/quotation/create",
    name: "QuotationCreate",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/quotation/create"),
  },
  {
    path: "/quotation/detail/:id",
    name: "QuotationDetail",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/quotation/detail"),
  },
  {
    path: "/quotation/copy/:id",
    name: "QuotationCopy",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/quotation/copy"),
  },
  {
    path: "/salesman",
    name: "Salesman",
    meta: {
      authRequired: true,
      authorize: [Role.BRAND_MANAGER, Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/account/salesman"),
  },
  {
    path: "/major/import",
    name: "MajorImport",
    meta: {
      authRequired: true,
      authorize: [Role.BRAND_MANAGER],
    },
    component: () => import("./views/major/import"),
  },
  {
    path: "/major/import/create",
    name: "MajorImportCreate",
    meta: {
      authRequired: true,
      authorize: [Role.BRAND_MANAGER],
    },
    component: () => import("./views/major/import-create"),
  },
  {
    path: "/major/import/detail/:id",
    name: "MajorImportDetail",
    meta: {
      authRequired: true,
      authorize: [Role.BRAND_MANAGER],
    },
    component: () => import("./views/major/import-detail"),
  },
  {
    path: "/major/export",
    name: "MajorExport",
    meta: {
      authRequired: true,
      authorize: [Role.BRAND_MANAGER],
    },
    component: () => import("./views/major/export"),
  },
  {
    path: "/major/export/create",
    name: "MajorExportCreate",
    meta: {
      authRequired: true,
      authorize: [Role.BRAND_MANAGER, Role.WAREHOUSE_KEEPER],
    },
    component: () => import("./views/major/export-create"),
  },
  {
    path: "/settings/account",
    name: "Account",
    meta: {
      authRequired: true,
      authorize: [Role.ADMIN],
    },
    component: () => import("./views/account/list"),
  },
  {
    path: "/accountant/agency/debt",
    name: "AgencyDebt",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/agency/debt"),
  },
  {
    path: "/accountant/agency/paid",
    name: "AgencyPaid",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/agency/paid"),
  },
  {
    path: "/accountant/agency/pay",
    name: "AgencyPay",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/agency/pay"),
  },
  {
    path: "/accountant/agency/old-debt",
    name: "AgencyOldDebt",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/agency/old-debt"),
  },
  {
    path: "/accountant/salesman/debt",
    name: "SalesmanDebt",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/salesman/debt"),
  },
  {
    path: "/accountant/salesman/paid",
    name: "SalesmanPaid",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/salesman/paid"),
  },
  {
    path: "/accountant/salesman/pay",
    name: "SalesmanPay",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/salesman/pay"),
  },
  {
    path: "/accountant/salesman/old-debt",
    name: "SalesmanOldDebt",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/salesman/old-debt"),
  },
  {
    path: "/accountant/shipper/debt",
    name: "ShipperDebt",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/shipper/debt"),
  },
  {
    path: "/accountant/shipper/paid",
    name: "ShipperPaid",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/shipper/paid"),
  },
  {
    path: "/accountant/paid/:id",
    name: "PaidDetail",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/paid-detail"),
  },
  {
    path: "/accountant/shipper/pay",
    name: "ShipperPay",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/shipper/pay"),
  },
  {
    path: "/accountant/shipper/old-debt",
    name: "ShipperOldDebt",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/shipper/old-debt"),
  },
  {
    path: "/accountant/customer/debt",
    name: "CustomerDebt",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/customer/debt"),
  },
  {
    path: "/accountant/customer/paid",
    name: "CustomerPaid",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/customer/paid"),
  },
  {
    path: "/accountant/customer/pay",
    name: "CustomerPay",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/customer/pay"),
  },
  {
    path: "/accountant/customer/old-debt",
    name: "CustomerOldDebt",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/accountant/customer/old-debt"),
  },
  {
    path: "/search/result",
    name: "SearchResult",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES],
    },
    component: () => import("./views/search/result"),
  },
  {
    path: "/analytic/customer",
    name: "AnalyticCustomer",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES],
    },
    component: () => import("./views/analytic/customer/list"),
  },
  {
    path: "/analytic/customer/:id",
    name: "AnalyticCustomerDetail",
    meta: {
      authRequired: true,
      authorize: [Role.TELESALES],
    },
    component: () => import("./views/analytic/customer/detail"),
  },
  {
    path: "/promotion/customer-group",
    name: "PromotionGroupCustomer",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/customer-group"),
  },
  {
    path: "/promotion/customer-group/create",
    name: "PromotionGroupCustomerCreate",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/customer-group-create"),
  },
  {
    path: "/promotion/customer-group/detail/:id",
    name: "PromotionGroupCustomerDetail",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/customer-group-detail"),
  },
  {
    path: "/promotion/customer-group/copy/:id",
    name: "PromotionGroupCustomerCopy",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/customer-group-copy"),
  },
  {
    path: "/promotion/brand",
    name: "PromotionBrand",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/brand"),
  },
  {
    path: "/promotion/brand/create",
    name: "PromotionBrandCreate",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/brand-create"),
  },
  {
    path: "/promotion/brand/detail/:id",
    name: "PromotionBrandDetail",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/brand-detail"),
  },
  {
    path: "/promotion/brand/copy/:id",
    name: "PromotionBrandCopy",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/brand-copy"),
  },
  {
    path: "/promotion/distributor",
    name: "PromotionDistributor",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/distributor"),
  },
  {
    path: "/promotion/distributor/create",
    name: "PromotionDistributorCreate",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/distributor-create"),
  },
  {
    path: "/promotion/distributor/detail/:id",
    name: "PromotionDistributorDetail",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/distributor-detail"),
  },
  {
    path: "/promotion/distributor/copy/:id",
    name: "PromotionDistributorCopy",
    meta: {
      authRequired: true,
      authorize: [Role.DEBT_ACCOUNTANT],
    },
    component: () => import("./views/promotion/distributor-copy"),
  },
  {
    path: "/change-log",
    name: "ChangeLog",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/other/change-log"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset-password",
    name: "Tạo mật khẩu",
    component: () => import("./views/account/reset-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      // param: routeTo, routeFrom, next
      beforeResolve() {
        store.dispatch("auth/logOut").then();
        // const authRequiredOnPreviousRoute = routeFrom.matched.some(
        //     (route) => route.push('/login')
        // )
        // // Navigate back to previous page, or home as a fallback
        // next(authRequiredOnPreviousRoute ? {name: 'default'} : {...routeFrom})
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/other/404").default,
  },
  {
    path: "*",
    redirect: "404",
  },
];
